import { FC } from 'react';
import { AllFiltersLayout } from 'shared/components/AllFiltersLayout/AllFiltersLayout';
import { useAvailableFilters } from 'shared/hooks';
import { ALL_FILTERS_SET } from './constants';
import { PikBannerInFiltersContainer } from '../../../AdvancedFiltersContainer/containers/AdvancedFiltersContentContainer/containers/PikBannerInFiltersContainer';
import { ALL_FILTERS_MAP } from './constants/filtersMap';

export const AllFiltersContentContainer: FC = () => {
  const filters = useAvailableFilters({ filtersSet: ALL_FILTERS_SET, filtersComponentsMap: ALL_FILTERS_MAP });

  return <AllFiltersLayout filters={filters} pikBanner={<PikBannerInFiltersContainer />} />;
};
